import React from 'react';
import Clearfix from 'components/elements/clearfix';
import UserList from 'containers/UserContainer/UserList';

export default  class UserPanel extends React.Component {
  render() {
    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <UserList hideRightHeaderContent />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/AdminContainer/UserPanel/index.js